module.exports = __webpack_public_path__ + "img/empty.b853e7df.png";